import React from 'react';
import './PageCard.css';

function PlaceTrades() {
  return (
    <div className="page-card">
      <h2 className="page-title">Place Trades</h2>
      <div className="page-section">
        MT5 platform API will be loaded here. User ID and password will be used to connect and place buy/sell orders.<br />
        (Integrate with backend Python script for MT5 API.)
      </div>
    </div>
  );
}

export default PlaceTrades;
